import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';
import { Button, Popover, Position, Tag } from '@blueprintjs/core';
import ListPicker from 'components/ListPicker';
import SupplierAutocomplete from 'components/SupplierAutocomplete';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';

// Same statuses as the material items on the order; "none" finds orders
// that don't have one yet.
const STATUS_OPTIONS = [
  { label: 'No status', value: 'none' },
  { label: 'Pending order', value: 'pending order' },
  { label: 'Ordered', value: 'ordered' },
  { label: 'In transit', value: 'in transit' },
  { label: 'Received', value: 'received' },
  { label: 'Picked up by the technician', value: 'picked up by the technician' },
  { label: 'Archived', value: 'archived' },
];

@inject('store', 'workReportStore', 'viewStore') @observer
class PurchaseOrders extends Component {

  @action
  setWhere(changes) {
    const { viewStore } = this.props;
    viewStore.purchaseOrderItemSearch = {
      ...viewStore.purchaseOrderItemSearch,
      where: { ...viewStore.purchaseOrderItemSearch.where, ...changes },
    };
  }

  onSupplierSelect(supplier) {
    this.setWhere({ supplier_id: supplier ? supplier.id : null });
  }

  onStatusChange(selections) {
    this.setWhere({ status: selections.map((status) => status.value) });
  }

  onItemsCountChange(event) {
    this.setWhere({ items_count: event.target.value });
  }

  @action
  onTermChange(event) {
    const { viewStore } = this.props;
    viewStore.purchaseOrderItemSearch = {
      ...viewStore.purchaseOrderItemSearch,
      term: event.target.value,
    };
  }

  onEnter(event) {
    if (event.key === 'Enter') this.search();
  }

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.purchaseOrderItemSearch.page = 1;
    viewStore.PurchaseOrder();
    this.props.workReportStore.loadPurchaseOrders();
  }

  render() {
    let {
      viewStore: {
        purchaseOrderItemSearch: {
          term,
          where
        }
      },
      workReportStore: {
        purchaseOrderItem: {
          isLoading
        }
      }
    } = this.props;
    const statuses = (where && where.status) || [];

    return(
      <SearchFiltersToolbar
        searchButton={
          <SearchFiltersSearchButton
            onClick={this.search.bind(this)}
            loading={isLoading}
          />
        }
      >
        <input
          type="text"
          className="bp3-input input-control search-filters-toolbar__field-wide"
          placeholder="PO number, supplier, item or part number"
          aria-label="Search purchase orders"
          defaultValue={term && term !== '*' ? term : ''}
          onChange={this.onTermChange.bind(this)}
          onKeyPress={this.onEnter.bind(this)}
        />
        <SupplierAutocomplete
          selectedSupplierId={where && where.supplier_id}
          onSupplierSelect={this.onSupplierSelect.bind(this)}
        />
        <Popover
          minimal={true}
          content={
            <ListPicker
              selectedOptions={statuses}
              options={STATUS_OPTIONS}
              onChange={this.onStatusChange.bind(this)}
            />
          }
          position={Position.BOTTOM_LEFT}
          usePortal={true}
        >
          <Button rightIcon="caret-down">
            Status
            <span>&nbsp;</span>
            <Tag minimal={true} round={true}>{statuses.length}</Tag>
          </Button>
        </Popover>
        <input
          type="number"
          min="1"
          step="1"
          inputMode="numeric"
          className="bp3-input input-control"
          placeholder="Number of items"
          aria-label="Number of items"
          defaultValue={(where && where.items_count) || ''}
          onChange={this.onItemsCountChange.bind(this)}
          onKeyPress={this.onEnter.bind(this)}
        />
      </SearchFiltersToolbar>
    )
  }

}

export default PurchaseOrders;
